import BaseModel from '../../base';
import Event from '../../event';

import constants, { REQUEST_STATUS } from './constants';
import glossary, { REQUEST_STATUS_DATA } from './glossary';

export default class AssociationEventRequest extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.association = item.association || item.event_association || null;
    this.event = item.event ? new Event(item.event, 'events') : null;
    this.event_association = item.event_association || null;
    this.items = (Array.isArray(item.items) ? item.items : []).map((requestItem) => ({
      ...requestItem,
      event_nomination: requestItem.event_nomination || null,
      event_association_feature_value: requestItem.event_association_feature_value || null,
    }));

    const status = item.request_status || item.status || item.event_association_status || REQUEST_STATUS.new;
    this.status = status;
    this.request_status = status;
    this.event_association_status = item.event_association_status || status;

    this.event_id = item.event_id || this.event?.id || null;
    this.association_id = item.association_id || this.association?.id || this.event_association?.id || null;
    this.event_association_id = item.event_association_id || this.event_association?.id || null;

    this.created_at = item.created_at || item.request_created_at || null;
    this.request_created_at = item.request_created_at || item.created_at || null;
    this.updated_at = item.updated_at || null;

    const baseName = this.name || null;
    const eventName = this.event?.short_name || this.event?.name || null;

    this.short_name = item.short_name || eventName || null;
    this.name = item.name || this.short_name || this.association?.name || this.event_association?.name || baseName;
  }

  get statusData() {
    const { status } = this;
    const data = REQUEST_STATUS_DATA[status];
    return {
      ...data,
      isNew: status === REQUEST_STATUS.new,
      isAccepted: status === REQUEST_STATUS.accepted,
      isRejected: status === REQUEST_STATUS.rejected,
    };
  }

  get requestStatusData() {
    return this.statusData;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
